
export default {
  name: 'FiveStarProductsFilterSection',

  props: {
    categoryData: {
      type: Array,
      default: () => ([]),
    },
  },

  data() {
    return { 
      activeItemId: 0,
    }
  },
  computed: {
  },
  methods: {
    currentCategoryTitle() {
      if (!this.$route.params.productCat) return this.$t('fiveStar.filterMenuAll')
      return this.categoryDataInOrder()?.find((item) => item.slug === this.$route?.params?.productCat )?.CategoryTitle
    },
    categoryDataInOrder() {
      function compare( a, b ) {
        if ( a.DisplayOrder < b.DisplayOrder ){
          return -1;
        }
        if ( a.DisplayOrder > b.DisplayOrder ){
          return 1;
        }
        return 0;
      }
      const ordered = JSON.parse(JSON.stringify(this.categoryData)); 
      return ordered?.sort( compare );
    },
    toggleActiveItem(i) {
      if (i === this.activeItemId) {
        this.activeItemId = -1
      } else {
        this.setActiveItem(i)
      }
    },

    setActiveItem(i) {
      this.activeItemId = i
    }
  },
}
